export default "__VITE_ASSET__D$nOauXs__"